module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pagination-list"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setActivePage(_vm.activePage - 1)
      }
    }
  }, [_c('li', {
    staticClass: "page-number",
    class: {
      'disabled': _vm.activePage === 1
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setActivePage(1)
      }
    }
  }, [_c('li', {
    staticClass: "page-number",
    class: {
      'active': _vm.activePage === 1
    }
  }, [_vm._v("\n\t\t\t1\n\t\t")])]), _vm._v(" "), _c('a', [(_vm.activePage !== 1 && _vm.activePage !== 2 && _vm.activePage !== 3) ? _c('li', {
    staticClass: "page-number elipsis"
  }, [_vm._v("\n\t\t\t...\n\t\t")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.pagesArray), function(page, index) {
    return _c('a', {
      on: {
        "click": function($event) {
          _vm.setActivePage(page)
        }
      }
    }, [(_vm.showPageIndex(index)) ? _c('li', {
      staticClass: "page-number",
      class: {
        'active': _vm.activePage === page
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(page) + "\n\t\t")]) : _vm._e()])
  }), _vm._v(" "), _c('a', [(_vm.activePage !== _vm.pagesArray.length && _vm.activePage !== _vm.pagesArray.length - 1 && _vm.activePage !== _vm.pagesArray.length - 2) ? _c('li', {
    staticClass: "page-number elipsis"
  }, [_vm._v("\n\t\t\t...\n\t\t")]) : _vm._e()]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setActivePage(_vm.pagesArray.length)
      }
    }
  }, [(_vm.numPages !== 1) ? _c('li', {
    staticClass: "page-number",
    class: {
      'active': _vm.activePage === _vm.pagesArray.length
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.pagesArray.length) + "\n\t\t")]) : _vm._e()]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setActivePage(_vm.activePage + 1)
      }
    }
  }, [_c('li', {
    staticClass: "page-number",
    class: {
      'disabled': _vm.activePage === _vm.numPages
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc683118"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Pagination.vue
// module id = 797
// module chunks = 0